import { PaginationDto } from "./common/pagination";

export interface ReasonModel {
  id: number;
  description: string;
  isActive: boolean;
  activeStatus: string;
  reasonTypeId: number;
  reasonTypeText: string;
  creationDate: string;
}
export interface SearchReasonInputDto extends PaginationDto {
  reasonTypeId?: number | null;
  keyWord?: string;
}
export interface CreateUpdateReasonModel {
  id: number;
  description: string;
  reasonTypeId?: number | null;
}
export enum ReasonTypeEnum {
  Suspended = 72,
  Cancelled = 73,
}
